import { useRouter } from 'next/router'
import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import theme from 'src/utils/themeUser'
import MuiCard, { CardProps } from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import { forgotPassword } from 'src/apis/user/auth'
import CommonPasswordForgotPage from 'src/components/pages/common/CommonPasswordForgotPage'

const Card = styled(MuiCard)<CardProps>(({ theme }) => ({
  [theme.breakpoints.up('sm')]: { width: '28rem' },
}))

const PasswordForgotPage = () => {
  const { pathname } = useRouter()
  const pathName = pathname.split('/')[1]

  return (
    <ThemeProvider theme={theme}>
      <Box className='content-center'>
        <Card sx={{ zIndex: 1 }}>
          <CardContent sx={{ padding: theme => `${theme.spacing(5, 5, 0)} !important` }}>
            <CommonPasswordForgotPage pathName={pathName} forgotPassword={forgotPassword} />
          </CardContent>
        </Card>
      </Box>
    </ThemeProvider>
  )
}

export default PasswordForgotPage
